import apiClient from '../connections/api'

export default {
    getNotifications: () => {
        return apiClient.get('/notifications')
    },
    markAsRead: (id) => {
        return apiClient.patch(`/notifications/${id}/read`)
    },
    resolve: (id) => {
        return apiClient.patch(`/notifications/${id}/resolve`)
    }
}
